<template>
  <section>
    <ul>
      <li class="blue">國一</li>
      <li class="red">國二</li>
      <li class="yellow">國三</li>
    </ul>
    <div class="row">
      <div :class="{ highligh: currentMonth == 1 }">
        <img src="../assets/january-black.svg" />
        <div class="item">
          <span class="label yellow">1月寒假前</span>
          <span>國三課程結束，開始總複習</span>
        </div>
        <div class="item">
          <span class="label yellow">1月中旬</span>
          <span>國三會考模考衝刺寒密班開課</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 2 }">
        <img src="../assets/february-black.svg" />
        <div class="item">
          <span class="label red">2月中旬</span>
          <span>國二下社會班開課</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 3 }">
        <img src="../assets/march-black.svg" />
        <div class="item">
          <span class="label yellow">3月中旬</span>
          <span>一中科學班初試＋隔週複試</span>
        </div>
        <div class="item">
          <span class="label blue">3月下旬</span>
          <span>國一各科課程開放試聽</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ highligh: currentMonth == 4 }">
        <img src="../assets/april-black.svg" />
        <div class="item">
          <span class="label blue">4月上旬</span>
          <span>
            衛道科學班、明道拔尖班考前衝刺班開課<br />國中資優鑑定考前衝刺班開課
          </span>
        </div>
        <div class="item">
          <span class="label blue">4月中旬</span>
          <span>國一課程開課</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 5 }">
        <img src="../assets/may-black.svg" />
        <div class="item">
          <span class="label yellow">5月中旬</span>
          <span>教育會考</span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 6 }">
        <img src="../assets/june-black.svg" />
        <div class="item">
          <span class="label blue">6月初</span>
          <span>國中資優班鑑定</span>
        </div>
        <div class="item">
          <span class="label blue">6月中旬</span>
          <span>衛道科學班、衛道ESL班、明道拔尖班測驗</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div :class="{ highligh: currentMonth == 7 }">
        <img src="../assets/july-black.svg" />
        <div class="item">
          <span class="label blue">7月上旬</span>
          <span>理化班開課（衛道專班除外）</span>
        </div>
        <div class="item">
          <span class="label red">7月上旬</span>
          <span>升國三暑密班三週</span>
        </div>
        <div class="item">
          <span class="label yellow">7月中旬</span>
          <span>
            一女中數理資優班初試＋複試<br />女中創科班、人社班 資格審查＋面試
          </span>
        </div>
      </div>
      <div :class="{ highligh: currentMonth == 8 }">
        <img src="../assets/august-black.svg" />
        <div class="item">
          <span class="label red">7月－8月</span>
          <span>升國三地科班八堂課</span>
        </div>
      </div>
      <div>
        <!-- Use to make flex works -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      currentMonth: new Date().getMonth() + 1
    };
  }
};
</script>

<style lang="scss" scoped>
.row {
  border-bottom: 1px solid rgba(153, 158, 99, 0.34);
  display: flex;
  flex-direction: row;
  padding: 16px 0;
  margin: 0 44px;

  &:last-child {
    border-bottom: none;
  }

  > div {
    flex: 1;
    margin: 0 2px;
    padding: 27px 15px;

    img {
      display: block;
      margin-bottom: 15px;
    }
  }
}

.item {
  display: flex;
  margin-bottom: 10px;

  > span {
    display: block;
    font-weight: bold;
    font-size: 18px;
    color: #6b6b6b;
  }

  .label {
    text-align: center;
    border-radius: 5px;
    min-width: 90px;
    padding: 2px;
    font-size: 16px;
    color: white;
    margin-right: 9px;
    display: inline-table;

    &.blue {
      background-color: #1a5773;
    }
    &.red {
      background-color: #c96861;
    }
    &.green {
      background-color: #999e63;
    }
    &.yellow {
      background-color: #ebb300;
    }
  }
}

ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 70px;
  padding: 0;

  li {
    color: #676767;
    display: flex;
    flex-direction: row;
    font-size: 18px;
    font-weight: bold;
    align-items: center;
    margin: 0 20px;

    &:before {
      content: "";
      display: content;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 10px;
    }

    &.blue:before {
      background-color: #1a5773;
    }

    &.red:before {
      background-color: #c96861;
    }

    &.yellow:before {
      background-color: #e9b91f;
    }
  }
}

.highligh {
  background-color: #fffbe6;
  border-radius: 8px;
}

@media (max-width: 480px) {
  .row {
    flex-direction: column !important;
    border: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin: 0 !important;

    > div {
      margin-bottom: 40px;
      padding: 27px 40px;
    }
  }

  ul {
    margin: 30px auto;
    li {
      margin: 0 10px !important;
    }
  }

  .highligh {
    border-radius: 0 !important;
  }
}
</style>
